import AntdNotification from 'antd/lib/notification';

const notification = {
    ...AntdNotification,
}
export default notification;



// WEBPACK FOOTER //
// ./src/components/notification/index.tsx